<template>
<v-card class="card-custom" flat height="100%" max-height="350px" style="overflow-y: auto">
    <v-card-text>
        <div class="important py-2">
            {{ $t('room_type.detail.title.rate_plan_association') }}
        </div>
        <div v-if="rate_plans.length < 1">
            {{ $t('room_type.detail.message_no_rate_plans') }}
        </div>
        <div v-else class="px-2">
            <v-checkbox v-for="rate_plan in rate_plans" :key="rate_plan.id" class="im-check-box ma-0 pa-0" v-model="plans_selected" :value="rate_plan.id" color="primary">
                <template v-slot:label>
                    <span>{{rate_plan.name}}</span>
                    <span class="faded">({{rate_plan.id}})</span>
                </template>
            </v-checkbox>
        </div>
        <div v-if="admin" class="d-flex align-center">
            <div class="px-2">Pretul camerei incepe de la</div>
            <v-text-field :label="$t('room_type.detail.price')" v-model="item.price" :suffix="currency" />
        </div>
    </v-card-text>

</v-card>
</template>

<script>
import {
    mapActions
} from 'vuex';
import storage from '../../../../storage';
import logger from '../../../../logger.js';
export default {
    props: {
        item: Object,
        hotel_id: [String, Number],
        currency: {
            type: String,
            default: 'RON'
        },
        rate_plans_selected: Array
    },
    name: `hotel-details`,
    components: {},
    data() {
        return {
            admin: false,
            plans_selected: this.rate_plans_selected,
            rate_plans: [],

        };
    },

    created() {
        this.getRatePlans();
    },

    watch: {
        plans_selected: {
            handler() {
                this.$emit('updateRatePlan', this.plans_selected);
            }
        },
        rate_plans_selected: {
            handler() {
                this.plans_selected = this.rate_plans_selected;
            }
        }
    },

    computed: {},

    async mounted() {
        let roles = await storage.getRoles();
        this.admin = (roles.ssr_console.includes('admin'));
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        getRatePlans() {
            if(!this.hotel_id) {
                return
            }

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/rate-plans";

            // setup query params
            let params = {
                params: {
                    hotel_id: this.hotel_id
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    this.rate_plans = response.data.data;
                    if(!this.$route.params.id) {
                        this.rate_plans.map(room => this.plans_selected.push(room.id))
                    }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },


    },
};
</script>
